module.exports = __webpack_public_path__ + "img/flecheCard.49651990.svg";